
import _ from 'lodash'
import { mapGetters } from 'vuex'
import card from '~/mixins/card'
import { attachmentHref, attachmentExcludeKey, isAttachmentExcludedBy } from '~/util/files'

export default {
    mixins: [card],
    props: {
        value: {
            type: Object,
            default () { return {} }
        },
    },
    data () {
        return {
            form: {
                excluded: [],
            },
            unwatch: null,
        }
    },
    computed: {
        ...mapGetters([
            'summaryAttachments'
        ]),
    },
    watch: {
        value () {
            if (!_.isEqual(this.value, this.form)) {
                this.updateForm()
            }
        },
    },
    mounted () {
        this.updateForm()
        this.unwatch = this.$watch('form', {
            deep: true,
            handler () {
                this.$emit('input', _.cloneDeep(this.form))
            }
        })
    },
    destroyed () {
        this.unwatch && this.unwatch()
    },
    methods: {
        // drschoice/flow#615: links go through the API, never the S3 bucket.
        attachmentHref,
        attachmentExcludeKey,
        isAttachmentExcludedBy,
        updateForm () {
            this.form = { excluded: [], ..._.cloneDeep(this.value || {}) }
            this.$emit('input', _.cloneDeep(this.form))
        },
    }
}
